export const SendEventToGoogleTagMngr = function (event, props) {
    let googleTagManagerObject = {
        event: event,
        ...props,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(googleTagManagerObject);
};
